import { render, staticRenderFns } from "./Podcast.vue?vue&type=template&id=b2f65a98&scoped=true&lang=html&"
import script from "./Podcast.vue?vue&type=script&lang=js&"
export * from "./Podcast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f65a98",
  null
  
)

export default component.exports